import { ReactNode, useEffect, useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface RouteTransitionProps {
  children: ReactNode;
}

export const RouteTransition = ({ children }: RouteTransitionProps) => {
  const location = useLocation();

  // Use useLayoutEffect for instant scroll before paint (faster perceived navigation)
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  // Minimal, fast animation for smoother navigation
  return (
    <div 
      className="animate-fade-in-fast"
      style={{ 
        animationDuration: '150ms',
        animationFillMode: 'both',
      }}
    >
      {children}
    </div>
  );
};
